import {atom} from "recoil";
import {SelectElementModelFE} from "../api/types/generic";

export interface IFormSearchLeadModel {
    legalEntity: { name: string } | null
}

export const initialLeadModelFilters: IFormSearchLeadModel = {
    legalEntity: null
};

export const leadModelFiltersAtom = atom<IFormSearchLeadModel>({
    key: "leadModelFiltersAtom",
    default: initialLeadModelFilters
});
